export default "__VITE_ASSET__C9IrDJN$__"